import { enumXMLType } from "../constants";

export function XML_RenderGroupStart(drawElement) {
  var docType = drawElement.GetDocType();

  if (docType != enumXMLType.PDF) {
    var s = drawElement.GetStream();
    drawElement.OutputElementHead(s, "grp");
  }
}
